import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=1c672886&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=1c672886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c672886",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {XcoinsMoreProducts: require('/var/jenkins_home/workspace/prod-web-xfans/components/xcoins/MoreProducts.vue').default,XcoinsStatusDialog: require('/var/jenkins_home/workspace/prod-web-xfans/components/xcoins/StatusDialog.vue').default})
